import { PlannerResourceType } from "@parkschannel/contracts";
export class PlannerTree {
    static fromPlannerResourceDto(dto) {
        return new PlannerTree(dto);
    }
    get plannerCategories() {
        return this.planner_tree.reduce(getTreeCategories, []);
    }
    get plannerPlaces() {
        return this.planner_tree.reduce(getTreePlaces, []);
    }
    get plannerProducts() {
        return this.planner_tree.reduce(getTreeProducts, []);
    }
    get plannerActivities() {
        return this.planner_tree.reduce(getTreeActivities, []);
    }
    toFilter(items) {
        return items.map((item)=>({
                label: item.title,
                value: item.id
            }));
    }
    toJSON() {
        return {
            planner_tree: this.planner_tree,
            plannerCategories: this.plannerCategories,
            plannerPlaces: this.plannerPlaces,
            plannerActivities: this.plannerActivities,
            plannerProducts: this.plannerProducts,
            toFilter: this.toFilter
        };
    }
    constructor(planner_tree){
        this.planner_tree = planner_tree;
    }
}
function getTreeCategories(acc, curr) {
    if (curr.plannerResource === PlannerResourceType.CATEGORY) {
        return [
            ...acc,
            curr
        ];
    }
    if (Array.isArray(curr.children)) {
        const children = curr.children.reduce(getTreeCategories, []);
        return [
            ...acc,
            ...children
        ];
    }
    return acc;
}
function getTreeProducts(acc, curr) {
    if (curr.plannerResource === PlannerResourceType.PRODUCT) {
        return [
            ...acc,
            curr
        ];
    }
    if (Array.isArray(curr.children)) {
        const children = curr.children.reduce(getTreeProducts, []);
        return [
            ...acc,
            ...children
        ];
    }
    return acc;
}
function getTreePlaces(acc, curr) {
    if (curr.plannerResource === PlannerResourceType.PLACE) {
        return [
            ...acc,
            curr
        ];
    }
    if (Array.isArray(curr.children)) {
        const children = curr.children.reduce(getTreePlaces, []);
        return [
            ...acc,
            ...children
        ];
    }
    return acc;
}
function getTreeActivities(acc, curr) {
    if (curr.plannerResource === PlannerResourceType.ACTIVITY) {
        return [
            ...acc,
            curr
        ];
    }
    if (Array.isArray(curr.children)) {
        const children = curr.children.reduce(getTreeActivities, []);
        return [
            ...acc,
            ...children
        ];
    }
    return acc;
}
